import { render, staticRenderFns } from "./DescargaEncuesta.vue?vue&type=template&id=5d0cdd7a&scoped=true&"
import script from "./DescargaEncuesta.vue?vue&type=script&lang=js&"
export * from "./DescargaEncuesta.vue?vue&type=script&lang=js&"
import style0 from "./DescargaEncuesta.vue?vue&type=style&index=0&id=5d0cdd7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0cdd7a",
  null
  
)

export default component.exports